import Header from 'components/Header';
import { Wrapper, StyledBody } from './Layout.styles';

interface LayoutProps {
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
  hideHeader?: boolean;
}

const Layout = ({ children, ariaLabel, className, hideHeader = false }: LayoutProps) => (
  <Wrapper>
    {!hideHeader && <Header />}
    <StyledBody aria-label={ariaLabel} className={className}>
      {children}
    </StyledBody>
  </Wrapper>
);

export default Layout;
